import { Container } from "../Home/HomeStyles";
import { Header, SideMenu } from "../../Components";
import ReDatePicker from "../../unity-ui-common/Components/ReFormFields/ReDatePicker";
import ReusableForm from "../../unity-ui-common/Components/ReForm";
import { Card, Form } from "antd";
import { Uniview } from "../../API/Uniview";
import { convertPickedDateRangeToUTC } from "../../Helper/Methods";
export default function ConsolidatedReport() {
  const [form] = Form.useForm();
  async function generateConsolidatedReport(dateRange: any) {
    const univiewService = new Uniview("distributions", "consolidatedReport");
    const { start, end } = convertPickedDateRangeToUTC(dateRange);
    dateRange = {
      ">": start,
      "<": end,
    };
    await univiewService.generateCSV(
      {},
      {},
      { day0: dateRange },
      "Cumulative Raw Data Report"
    );
  }
  async function handleFormSubmitButtonClicks(values: any) {
    generateConsolidatedReport(values?.day0);
  }

  return (
    <Container>
      <Card
        title={
          <h5 style={{ marginBottom: "0" }}>Cumulative Raw Data Report</h5>
        }
        bordered={false}
        style={{ width: 500, height: 230 }}
      >
        <ReusableForm
          formInstance={form}
          onSubmit={handleFormSubmitButtonClicks}
          submitBtn
          submitBtnText="Generate"
        >
          <ReDatePicker
            label="Day 0"
            name="day0"
            type="rangePicker"
            dateFormat="DD-MMM-YYYY"
            width="100%"
            featureDates
            required
          />
        </ReusableForm>
      </Card>
    </Container>
  );
}
